import { Fuel, Gauge, Cpu, SlidersHorizontal, Zap, Wind, Filter, Droplets, Waves, Volume2, Cog, Rocket, Trophy, Activity, CircleOff, RotateCcw, Flame } from "lucide-react";

export const services = [
  {
    slug: "reprogrammation-e85",
    title: "Reprogrammation E85",
    icon: Fuel,
    accent: "#6EB000",
    script: "Roulez moins cher, gardez votre voiture",
    intro:
      "La reprogrammation E85 permet à votre moteur essence de fonctionner au bioéthanol, un carburant jusqu'à ≈ 1,20 €/L moins cher que le SP95. Après une étude de compatibilité sérieuse, j'adapte la cartographie d'injection de votre véhicule pour un fonctionnement fiable au quotidien.",
    benefits: [
      "Jusqu'à ≈ 1,20 €/L d'économie à la pompe",
      "Vous gardez votre voiture actuelle",
      "Étude de compatibilité avant toute intervention",
      "Cartographie sur mesure, pas de fichier générique",
    ],
    steps: [
      "Diagnostic électronique complet et étude de compatibilité",
      "Extraction et adaptation sur mesure de votre cartographie",
      "Essais et contrôle après reprogrammation",
    ],
    disclaimer: null,
  },
  {
    slug: "reprogrammation-diesel",
    title: "Reprogrammation diesel",
    icon: Gauge,
    accent: "#F5A623",
    script: "Plus de couple, une conduite plus souple",
    intro:
      "La reprogrammation de votre moteur diesel optimise le couple et l'agrément de conduite, sans promesse excessive. Selon votre utilisation, la consommation peut également être réduite. Chaque intervention est adaptée à l'état réel de votre moteur.",
    benefits: [
      "Couple moteur optimisé dès les bas régimes",
      "Conduite plus souple au quotidien",
      "Consommation potentiellement réduite selon votre usage",
      "Intervention adaptée, sans exagération",
    ],
    steps: [
      "Diagnostic et lecture de l'état moteur",
      "Cartographie sur mesure selon votre véhicule",
      "Essai routier et vérifications finales",
    ],
    disclaimer: null,
  },
  {
    slug: "stage-1",
    title: "Stage 1",
    icon: Zap,
    accent: "#6EB000",
    script: "Le premier pas vers plus de performances",
    intro:
      "Le Stage 1 est une optimisation logicielle complète de votre moteur, sans modification mécanique. Puissance et couple sont augmentés dans les limites de fiabilité de votre véhicule, pour un gain sensible d'agrément à l'accélération comme en reprise.",
    benefits: [
      "Gain de puissance et de couple mesurable",
      "Aucune modification mécanique nécessaire",
      "Réversible sur simple demande",
      "Réalisé dans les tolérances constructeur",
    ],
    steps: [
      "Contrôle de santé moteur et diagnostic",
      "Optimisation logicielle sur mesure",
      "Essais et validation des gains",
    ],
    disclaimer: null,
  },
  {
    slug: "stage-1-plus",
    title: "Stage 1+",
    icon: Zap,
    accent: "#F5A623",
    script: "L'optimisation avancée, sans toucher au matériel",
    intro:
      "Le Stage 1+ pousse l'optimisation logicielle plus loin qu'un Stage 1 classique : paramètres affinés pour tirer le meilleur de votre moteur d'origine, toujours sans modification mécanique et dans les limites de fiabilité du véhicule.",
    benefits: [
      "Optimisation plus poussée que le Stage 1",
      "Aucune modification mécanique nécessaire",
      "Réversible sur simple demande",
      "Réalisé dans les tolérances constructeur",
    ],
    steps: [
      "Contrôle de santé moteur et diagnostic",
      "Optimisation logicielle avancée sur mesure",
      "Essais, logs et validation des gains",
    ],
    disclaimer: null,
  },
  {
    slug: "egr-off",
    title: "EGR off",
    icon: Wind,
    accent: "#F5A623",
    script: "Un moteur qui respire proprement",
    intro:
      "La désactivation logicielle de la vanne EGR supprime le recyclage des gaz d'échappement, source fréquente d'encrassement d'admission et de pannes coûteuses. Votre moteur respire un air plus propre et conserve ses performances dans le temps.",
    benefits: [
      "Admission préservée de l'encrassement",
      "Moins de pannes liées à la vanne EGR",
      "Réponse moteur plus franche",
      "Intervention 100% logicielle",
    ],
    steps: [
      "Diagnostic du circuit EGR",
      "Désactivation logicielle dans la cartographie",
      "Contrôle et effacement des défauts",
    ],
    disclaimer: "Prestation réservée à un usage compétition ou hors route ouverte.",
  },
  {
    slug: "dpf-off",
    title: "DPF / FAP off",
    icon: Filter,
    accent: "#F5A623",
    script: "Fini les problèmes de FAP",
    intro:
      "La suppression logicielle du filtre à particules (FAP/DPF) met fin aux régénérations forcées, voyants moteur et modes dégradés. Une solution durable pour les véhicules dont le FAP devient une source de pannes récurrentes et de frais importants.",
    benefits: [
      "Suppression des régénérations forcées",
      "Plus de voyant FAP ni mode dégradé",
      "Contre-pression réduite, turbo préservé",
      "Économisez un remplacement coûteux",
    ],
    steps: [
      "Diagnostic du système de filtrage",
      "Désactivation logicielle du FAP",
      "Contrôle des paramètres post-intervention",
    ],
    disclaimer: "Prestation réservée à un usage compétition ou hors route ouverte. Dépose mécanique du filtre à prévoir le cas échéant.",
  },
  {
    slug: "adblue-off",
    title: "AdBlue off",
    icon: Droplets,
    accent: "#F5A623",
    script: "Plus de contrainte AdBlue",
    intro:
      "La désactivation logicielle du système AdBlue/SCR supprime les défauts liés au réservoir, à la pompe ou au capteur NOx — des pannes fréquentes et coûteuses qui peuvent immobiliser votre véhicule.",
    benefits: [
      "Plus d'alerte ni de compte à rebours AdBlue",
      "Suppression des défauts pompe et capteur NOx",
      "Évitez des réparations très coûteuses",
      "Intervention logicielle, sans modification majeure",
    ],
    steps: [
      "Diagnostic du système SCR/AdBlue",
      "Désactivation logicielle complète",
      "Effacement des défauts et essai",
    ],
    disclaimer: "Prestation réservée à un usage compétition ou hors route ouverte.",
  },
  {
    slug: "flaps-off",
    title: "Flaps off",
    icon: Waves,
    accent: "#6EB000",
    script: "Un collecteur débarrassé de ses clapets",
    intro:
      "Les clapets d'admission (swirl flaps) peuvent se gripper ou se détacher, avec un risque de casse moteur majeur. La désactivation logicielle, associée au kit de suppression adapté, élimine durablement ce risque.",
    benefits: [
      "Risque de casse moteur éliminé",
      "Plus de défauts liés aux clapets",
      "Flux d'admission stabilisé",
      "Solution préventive reconnue",
    ],
    steps: [
      "Diagnostic du collecteur d'admission",
      "Désactivation logicielle des flaps",
      "Contrôle après intervention",
    ],
    disclaimer: "Kit de suppression mécanique à prévoir selon le véhicule.",
  },
  {
    slug: "pop-and-bang",
    title: "Pop and bang",
    icon: Volume2,
    accent: "#F5A623",
    script: "Le son qui fait tourner les têtes",
    intro:
      "La cartographie Pop & Bang ajoute des crépitements et détonations à la décélération et au lever de pied, pour un caractère sonore sportif. Intensité réglable selon vos envies, sur véhicules compatibles.",
    benefits: [
      "Crépitements caractéristiques à la décélération",
      "Intensité ajustable selon vos préférences",
      "Cartographie dédiée, réversible",
      "Effet maximum sur échappement adapté",
    ],
    steps: [
      "Vérification de compatibilité moteur et échappement",
      "Intégration de la cartographie Pop & Bang",
      "Essai et réglage de l'intensité",
    ],
    disclaimer: "Usage réservé à la piste ou à un cadre privé. Usure prématurée possible de l'échappement.",
  },
  {
    slug: "stage-boite",
    title: "Stage boîte",
    icon: Cog,
    accent: "#6EB000",
    script: "Votre boîte auto, recalibrée",
    intro:
      "La reprogrammation de la boîte de vitesses automatique (DSG, ZF, etc.) optimise les passages de rapports : plus rapides en conduite sportive, plus doux au quotidien, avec des limites de couple adaptées à votre moteur reprogrammé.",
    benefits: [
      "Passages de rapports plus rapides",
      "Limites de couple adaptées au Stage 1",
      "Confort amélioré en conduite normale",
      "Parfait complément d'une reprogrammation moteur",
    ],
    steps: [
      "Diagnostic de la boîte de vitesses",
      "Recalibrage logiciel du calculateur boîte",
      "Essai routier et ajustements",
    ],
    disclaimer: null,
  },
  {
    slug: "diagnostic-electronique",
    title: "Diagnostic électronique",
    icon: Cpu,
    accent: "#F5A623",
    script: "Comprendre avant d'agir",
    intro:
      "Avant toute intervention, un diagnostic électronique complet permet de lire les défauts, d'analyser les paramètres moteur et de vérifier l'état réel de votre véhicule. C'est la garantie d'une intervention adaptée, jamais à l'aveugle.",
    benefits: [
      "Lecture complète des calculateurs",
      "Analyse honnête de l'état moteur",
      "Conseil clair sur les suites à donner",
      "Base indispensable de toute reprogrammation",
    ],
    steps: [
      "Branchement valise diagnostic multi-protocoles",
      "Analyse des défauts et paramètres",
      "Compte-rendu clair et sans jargon",
    ],
    disclaimer: null,
  },
  {
    slug: "cartographie-sur-mesure",
    title: "Cartographie sur mesure",
    icon: SlidersHorizontal,
    accent: "#6EB000",
    script: "Chaque moteur est unique",
    intro:
      "Pas de fichier générique téléchargé : votre cartographie est extraite de votre véhicule et adaptée point par point à son état, à votre usage et à vos objectifs. C'est la différence entre une reprogrammation sérieuse et un simple flash.",
    benefits: [
      "Fichier adapté à VOTRE moteur",
      "Prise en compte de l'état réel du véhicule",
      "Fiabilité préservée",
      "Réalisée par un professionnel passionné",
    ],
    steps: [
      "Extraction de la cartographie d'origine",
      "Adaptation sur mesure des paramètres",
      "Réécriture, essais et sauvegarde de l'origine",
    ],
    disclaimer: null,
  },
  {
    slug: "stage-2",
    title: "Stage 2",
    icon: Rocket,
    accent: "#F5A623",
    script: "Le niveau au-dessus, avec le hardware qui suit",
    intro:
      "Le Stage 2 combine une cartographie poussée et des modifications mécaniques légères (downpipe, admission, intercooler selon véhicule). Le gain de puissance est nettement supérieur au Stage 1, pour un usage enthousiaste assumé.",
    benefits: [
      "Gains nettement supérieurs au Stage 1",
      "Cartographie adaptée à vos modifications mécaniques",
      "Températures et pressions contrôlées",
      "Conseil sur le hardware adapté à votre objectif",
    ],
    steps: [
      "Bilan du véhicule et du hardware présent",
      "Cartographie Stage 2 sur mesure",
      "Essais, logs et validation des paramètres",
    ],
    disclaimer: "Modifications mécaniques associées pouvant impacter l'homologation route. Renseignez-vous avant intervention.",
  },
  {
    slug: "stage-3",
    title: "Stage 3",
    icon: Trophy,
    accent: "#6EB000",
    script: "Préparation complète, sans compromis",
    intro:
      "Le Stage 3 est une préparation moteur complète : turbo hybride ou supérieur, alimentation renforcée, cartographie intégralement sur mesure. Chaque projet est étudié au cas par cas, avec un cahier des charges précis.",
    benefits: [
      "Projet sur mesure selon votre objectif de puissance",
      "Cartographie développée spécifiquement pour votre config",
      "Suivi et ajustements après mise en route",
      "Conseil complet sur l'ensemble de la préparation",
    ],
    steps: [
      "Étude du projet et cahier des charges",
      "Développement de la cartographie dédiée",
      "Mise au point, logs et validations successives",
    ],
    disclaimer: "Projet destiné à un usage piste/compétition. Devis personnalisé obligatoire.",
  },
  {
    slug: "lambda-off",
    title: "Lambda removed",
    icon: Activity,
    accent: "#F5A623",
    script: "Décatalysez sans voyant",
    intro:
      "La désactivation logicielle de la sonde lambda aval supprime le voyant moteur et le mode dégradé liés à une décatalyse ou à un catalyseur défectueux. La solution propre pour les configurations compétition.",
    benefits: [
      "Plus de voyant moteur après décatalyse",
      "Suppression du mode dégradé",
      "Intervention 100% logicielle",
      "Idéal en complément d'un Stage 2",
    ],
    steps: [
      "Diagnostic du système antipollution",
      "Désactivation logicielle de la sonde concernée",
      "Contrôle et effacement des défauts",
    ],
    disclaimer: "Prestation réservée à un usage compétition ou hors route ouverte.",
  },
  {
    slug: "dtc-off",
    title: "DTC off",
    icon: CircleOff,
    accent: "#6EB000",
    script: "Supprimez un code défaut récurrent",
    intro:
      "La suppression ciblée de codes défauts (DTC) dans le calculateur permet de neutraliser un défaut précis et identifié — par exemple après suppression d'un équipement. Toujours après diagnostic, jamais pour masquer un vrai problème mécanique.",
    benefits: [
      "Suppression ciblée, code par code",
      "Diagnostic honnête avant intervention",
      "Calculateur préservé, modification propre",
      "Complément idéal des suppressions EGR/FAP/AdBlue",
    ],
    steps: [
      "Lecture et identification des codes défauts",
      "Désactivation ciblée dans le calculateur",
      "Vérification de l'absence de défauts",
    ],
    disclaimer: "Aucun défaut masqué sans diagnostic préalable de sa cause.",
  },
  {
    slug: "remise-origine",
    title: "Remise à l'origine",
    icon: RotateCcw,
    accent: "#F5A623",
    script: "Retournez à la configuration constructeur",
    intro:
      "Vente du véhicule, passage au contrôle technique, ou simple envie de revenir au stock : je réinjecte la cartographie d'origine de votre véhicule, sauvegardée lors de la première intervention.",
    benefits: [
      "Retour 100% configuration constructeur",
      "Fichier d'origine sauvegardé lors de la reprogrammation",
      "Intervention rapide",
      "Traçabilité complète de votre véhicule",
    ],
    steps: [
      "Identification de votre sauvegarde d'origine",
      "Réécriture du fichier constructeur",
      "Contrôle et essai",
    ],
    disclaimer: null,
  },
  {
    slug: "hardcut-limiter",
    title: "Hardcut limiter",
    icon: Flame,
    accent: "#6EB000",
    script: "Un rupteur brutal, façon course",
    intro:
      "Le hardcut limiter remplace le rupteur d'origine par une coupure brutale d'allumage/injection, produisant l'effet sonore caractéristique des voitures de course, avec flammes à l'échappement sur les moteurs compatibles.",
    benefits: [
      "Rupteur brutal façon compétition",
      "Effet sonore spectaculaire",
      "Régime de coupure réglable",
      "Combinable avec Pop and bang",
    ],
    steps: [
      "Vérification de compatibilité moteur",
      "Modification du gestionnaire de rupteur",
      "Essai et réglage du régime de coupure",
    ],
    disclaimer: "Usage réservé à la piste ou à un cadre privé. Contraintes mécaniques accrues.",
  },
];

export const getService = (slug) => services.find((s) => s.slug === slug);
